// extracted by mini-css-extract-plugin
export default {"home-room-sections-list-modal":"styles_home-room-sections-list-modal__Ot4mX"};